<button
  mat-flat-button
  class="search-button"
  [style.backgroundColor]="theme?.backgroundColor"
  [style.color]="theme?.textColor"
  (click)="onClickIcon()">
  <mat-icon class="left-icon">{{ showSearchInput ? 'close' : 'search' }}</mat-icon>
</button>
<mat-form-field
  appearance="outline"
  class="search-input"
  [ngClass]="{
    'not-white-theme': !closeToWhite(),
    'displaying-autocomplete': autocompleteOpen,
    'show-search-input': showSearchInput,
  }"
  [style.backgroundColor]="theme?.backgroundColor">
  <input
    type="text"
    matInput
    [placeholder]="'searchbar.search' | translate"
    #searchInput
    [(ngModel)]="query"
    (ngModelChange)="search$.next($event)"
    [matAutocomplete]="autoGroup"
    #trigger="matAutocompleteTrigger"
    autofocus />
  <mat-autocomplete
    #autoCompleteRef
    (opened)="panelOpened(searchInput, autoCompleteRef, trigger)"
    (closed)="searchMenuClosed()"
    #autoGroup="matAutocomplete"
    (optionSelected)="query = ''"
    (optionActivated)="query = ''">
    <mat-optgroup *ngFor="let group of stateGroupOptions | async" [label]="group.name | translate">
      <ng-container *ngIf="group.type === 'team'">
        <mat-divider></mat-divider>
        <mat-option
          *ngFor="let item of group.items"
          [disabled]="item.id === 'null'"
          [value]="item.team"
          (onSelectionChange)="trackOpenItem(item); openTeamResult(item)">
          {{ item.id === 'null' ? (item.team ?? '' | translate) : item.team
          }}<span
            class="option-description team-request-info"
            *ngIf="!item.teamExists && item.id !== 'null'"
            >{{ 'searchbar.teamRequest' | translate }}</span
          >
        </mat-option>
      </ng-container>
      <ng-container *ngIf="group.type === 'auctionItem'">
        <mat-divider></mat-divider>
        <mat-option
          *ngFor="let item of group.items"
          [disabled]="item.id === 'null'"
          [value]="item.title"
          (onSelectionChange)="
            trackOpenItem(item); openSearchResult({ url: item.id, type: group.type })
          ">
          {{ item.id === 'null' ? (item.title | translate) : item.title
          }}<span class="option-description" *ngIf="item.content">{{ item.content }}</span>
        </mat-option>
      </ng-container>
      <ng-container *ngIf="group.type === 'auction'">
        <mat-divider></mat-divider>
        <mat-option
          *ngFor="let item of group.items"
          [disabled]="item.id === 'null'"
          [value]="item.title"
          (onSelectionChange)="
            trackOpenItem(item); openSearchResult({ url: item.id, type: group.type })
          ">
          <ng-container *ngIf="item?.auctionState">
            <div
              [matBadge]="item.auctionState.charAt(0)"
              [class]="item.auctionState"
              matBadgeSize="small"
              class="event">
              {{ item.id === 'null' ? (item.title | translate) : item.title }}
            </div>
          </ng-container>
          <span class="option-description" *ngIf="item.content">{{ item.content }}</span>
        </mat-option>
      </ng-container>
    </mat-optgroup>
  </mat-autocomplete>
</mat-form-field>
